var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"000ee5942bacd6f94014c2982a05a5cc1ac58e36"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["espace-client@easycapital"]={id:"000ee5942bacd6f94014c2982a05a5cc1ac58e36"};
      